<template>
	<div class="alarm-list">
		<div
			v-once
			class="title"
		>
			Alarm List
		</div>
		<AlarmInput
			class="row"
			@new="addAlarm"
		/>
		<hr v-once>
		<div
			v-once
			class="controls"
		>
			<BaseButton @click="startAll">
				Start all
			</BaseButton>
			<BaseButton @click="stopAll">
				Stop all
			</BaseButton>
			<BaseButton @click="saveAll">
				Save all
			</BaseButton>
			<BaseButton @click="getAll">
				Get all
			</BaseButton>
		</div>
		<hr v-once>
		<div
			v-if="alarms.length > 0"
			class="alarms"
		>
			<div
				v-for="(alarm, index) in sortedAlarms"
				:key="alarm.id"
				:class="{ done: alarm.done }"
				class="row alarm-row"
			>
				<div class="index">
					{{ index + 1 }}
				</div>
				<AlarmItem
					v-bind="alarm"
					class="alarm-item"
					@done="alarm.done = true"
					@timeLeft="alarm.timeLeft = $event"
				/>
				<BaseButton
					v-once
					class="alarm-remove-button"
					@click="removeAlarm(alarm.id)"
				>
					Remove
				</BaseButton>
			</div>
		</div>
		<div
			v-else
			v-once
			class="row no-alarms"
		>
			No alarms
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import BaseButton from './BaseButton.vue';
import AlarmInput from './AlarmInput.vue';
import AlarmItem from './AlarmItem.vue';

const byTimeLeft = R.ascend(R.prop('timeLeft'));
const byTime = R.ascend(R.prop('time'));

export default {
	name: 'AlarmList',
	components: {
		AlarmInput,
		AlarmItem,
		BaseButton,
	},
	data() {
		return {
			alarms: [],
		};
	},
	computed: {
		sortedAlarms: {
			get() {
				return R.sortWith([byTimeLeft, byTime])(this.alarms);
			},
			set(alarms) {
				this.alarms = alarms;
			},
		},
	},
	methods: {
		addAlarm(alarm) {
			this.alarms.push(alarm);
		},
		removeAlarm(id) {
			this.alarms = R.reject(alarm => alarm.id === id)(this.alarms);
		},
		startAll() {
			this.alarms = R.map(R.assoc('paused', false))(this.alarms);
		},
		stopAll() {
			this.alarms = R.map(R.assoc('paused', true))(this.alarms);
		},
		saveAll() {
			if (this.alarms.length === 0) {
				return;
			}
			const alarms = JSON.stringify(this.alarms);
			window.localStorage.setItem('alarms', alarms);
		},
		getAll() {
			try {
				const alarms = JSON.parse(window.localStorage.getItem('alarms'));
				if (alarms.length === 0) {
					return;
				}
				this.alarms = alarms;
			} catch (e) {} // eslint-disable-line no-empty
		},
	},
};
</script>

<style lang="stylus" scoped>
@keyframes pulse
	from
		background-color rgba(0,255,0,0)
	to
		background-color rgba(0,255,0,0.2)

.alarm-list
	background-color #111

	> .title
		text-align center
		font-size 1.2rem

	> .no-alarms
		font-style italic
		display flex
		justify-content center
		align-items center

	.row
		height 2rem


	> .alarms
		> .alarm-row
			display flex
			justify-content space-between
			align-items center

			&.done
				animation-name pulse
				animation-direction alternate
				animation-duration 1s
				animation-iteration-count infinite
				animation-timing-function ease-in-out

			> .index
				width 2rem

			> .alarm-item
				width 80%

			> .alarm-remove-button
				height 100%

	@media (max-width: 800px)
		.row
			height auto
</style>



// WEBPACK FOOTER //
// src/components/AlarmList.vue